import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {useNavigate} from "react-router-dom";
import SecondaryButton from "../../components/SecondaryButton";
import {TextField,AlertColor,Button, Checkbox, FormControlLabel, Breadcrumbs } from "@mui/material";
import { Policy } from "../../objects/policy";
import { QuoteService } from "../../services/quoteservice";
import { LienHolderService } from "../../services/lienholderservice";
import InputMask from "react-input-mask";
import { Toast } from "../../components/alerts/toast";
import { DebounceTextField } from "../../components/DebounceTextField";
import { logActivityAsync } from "../../objects/events/loadEvents";
import dayjs from "dayjs";
import { UpdateQuoteByPropertyRequest } from "../../objects/UpdateQuoteByPropertyRequest";

function Questions(props:any){
    let lienHolderService = new LienHolderService();
    let quoteService = new QuoteService();

    var navigate = useNavigate();
    const dispatch = useDispatch();

    const policyStore = useSelector((state: any)=> state.policyReducer) as Policy;
    const [isPageLoad, setIsPageLoad] = useState(true);
    const [isAddDriverVisible, setIsAddDriverVisible] = useState(false);
    const [policy, setPolicy] = useState<Policy>(new Policy());

    const [isYesDocs, setIsYesDocs] = useState(true);
    
    const [mobilPhoneNum, setMobilePhoneNum] = useState("");
    const [emailAddress, setEmailAddress] = useState<string>("");
    const [hasEmailError, setHasEmailError] = useState<boolean>(false);

    const[isToastOpen, setIsToastOpen] = useState(false);
    const[toastSeverity, setToastSeverity] = useState<AlertColor>("success");
    const[alertMessages, setAlertMessages] = useState<string[]>([]);

    useEffect(() => {
        (async () => {
            await logActivityAsync(policy?.policyNumber ?? "", {
                recordKey: policy?.policyNumber,
                transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                action: "add_activity",
                subject: "Navigation",
                message: "Insured has navigated to the questions screen",
                isException:false,
                error: "",
                level:"INFO",
                isSent: false
            });
        })();
    }, []);

    useEffect(()=>{
        if(policyStore === undefined || policyStore == null){
            navigate("/" + window.location.search);
        }

        if(isPageLoad){
            window.scrollTo(0, 0);
            setPolicy(policyStore);
            setIsPageLoad(false);

            setEmailAddress(policyStore.emailAddress)
            var mobilePhone = policyStore?.phoneNumbers?.filter((e)=>{
                return e.type === "Mobile"
            })[0];
            setMobilePhoneNum(mobilePhone?.number ?? "");
        }
    }, [policy]);

    function NavigateBack(){
        navigate("/review" + window.location.search);
    }

    
    function NavigateForward(){    
        (async ()=> {         
            
            if(mobilPhoneNum === ""){
                return;
            }

            if(emailAddress === "" || !validateEmail(emailAddress)){
                setHasEmailError(true);
                return;
            }

            var updatedQuote = quoteService.updateMobilePhoneNumber(policy, mobilPhoneNum);
            updatedQuote.emailAddress = emailAddress;

            var update = { 
                policyNumber: updatedQuote.policyNumber,
                properties: [
                    {
                        propertyName: "EmailAddr",
                        propertyValue: updatedQuote.emailAddress,
                        propertyType: "string"
                    },
                    {
                        propertyName: "MobilePhoneNo",
                        propertyValue: mobilPhoneNum,
                        propertyType: "string"
                    }
                ]
            } as UpdateQuoteByPropertyRequest;

            var save = await quoteService.update(update);

            dispatch({type: "UPDATE", payload: updatedQuote})
  
            navigate("/payment" + window.location.search);
        })();        
    }

    function validateEmail(emailAddress: string) {
        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return emailAddress.match(mailformat) ? true : false;
    }

    return (
        <>
            <div className="container-add-vehicle w-100 pt-10">                
                <div className="w-[90vw] m-auto sm:w-[90vw] md:w-[90vw] lg:w-[90vw] xl:w-[60vw]">
                    <Breadcrumbs>
                        <h3 className="text-2xl pb-5 mt-0">Step 6 of 7</h3>
                    </Breadcrumbs>

                    <h3 className="text-3xl font-light  mb-10 w-full">
                        Alset Insurance cares about the environment and are paperless.
                        <br/>
                        Please confirm your email and mobile phone number, so we can keep in touch.
                    </h3>  

                    {/* <ListVehicles vehicles={policy.vehicles} /> */}
                    
                    <div className="grid grid-cols-12 gap-5 gap-y-6 pb-9">                
                        <div className="form-group col-span-12 sm:col-span-2 md:col-span-6 lg:col-span-4 xl:col-span-4">                            
                            <InputMask
                                mask="999-999-9999"
                                value={mobilPhoneNum}
                                disabled={false}
                                maskChar=" "
                                id="txtMobilePhoneNum"
                                name="MobilePhoneNum"                                                                
                                onChange={(e:any)=>{
                                    setMobilePhoneNum(e.target.value)
                                }}    
                                >
                               <TextField
                                label="Mobile Phone Number"
                                className="p-1 w-full" 
                                variant="outlined"
                                error={mobilPhoneNum === "" || mobilPhoneNum===null}
                                helperText={ (mobilPhoneNum === "" || mobilPhoneNum===null) ? "Mobile phone number is required" : ""}
                                />
                            </InputMask>
                        </div>  
                        <div className="form-group col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                           

                            <DebounceTextField 
                                id="txtEmailAddress"
                                name="EmailAddress"
                                label="Email Address"
                                value={emailAddress}
                                
                                onTextFieldChange={(e:any)=>{
                                    setEmailAddress(e.target.value)
                                    
                                    var isValid = validateEmail(e.target.value) || e.target.value === "";
                                    setHasEmailError(!isValid);
                                }}
                                hasError={hasEmailError}
                                helperText={hasEmailError ? "A valid email is required" : ""}
                            />
                            <span className="text-sm italic">We do not sell your email address or other personal information, but we may follow up with you about your quote</span>
                        </div>  
                    </div>

                    <FormControlLabel label="I elect to opt-in to electronic documents of all my documents." control={
                        <Checkbox name="chkbxDocsOptIn" checked={isYesDocs} onChange={(e)=>{setIsYesDocs(!isYesDocs)}} />
                    } />
                 
                </div>
            </div>
        
            <div className="mb-5  mt-10 p-5 bg-[#e0e1dd]">
                <div className="m-auto w-[90vw] sm:w-[90vw] md:w-[90vw] lg:w-[60vw] xl:w-[60vw]">                    
                    <SecondaryButton onClick={NavigateBack} variant="contained" className="p-2 w-1/3 sm:w-1/3 md:w-1/6 lg:w-1/6 xl:w-1/6 ">Back</SecondaryButton>
                    <Button variant="contained" className="btn-continue hover:cursor-pointer w-1/3 sm:w-1/3 md:w-1/6 lg:w-1/6 xl:w-1/6  float-right bg-[#0071eb] text-[#ffffff] rounded-md active:bg-[#0a58ca]" onClick={NavigateForward}>Continue</Button>
                    <div className="clear-both"></div>
                </div>
            </div>


            <Toast isOpen={isToastOpen} onClose={(e:any)=>{ setIsToastOpen(false); }} severity={toastSeverity} message={alertMessages} />
        </>
    );
}

export default Questions;